const { upgradeArray } = require('../utils')

const REPORTS_ENCODINGS = upgradeArray([ 'utf8', 'win1251', 'win1252', 'maccyrillic' ])

module.exports = {
  REPORTS_ENCODINGS
}
